<template>
    <div class="selectFoodList">
        <div class="left-cart-box">
            <div class="cart-title">点单信息</div>
            <div class="cart-box">
                <div class="food-li" v-for="(item,index) in freeList" :key="item">
                    <div class="flex1">
                        <div class="name nowrap">{{item.EAT_XFName}}</div>
                        <div class="detail">
                            <span>单价:￥{{item.Eat_CheckPrice}}/{{item.Eat_XFSize}}</span>
                            <span>小计:￥{{Number((item.Eat_CheckPrice * item.Eat_Number).toFixed(2))}}</span>
                        </div>
                    </div>
                    <div class="num-box">
                        <div class="remove" @click="removeItem(item,index)"><i class="iconfont icon-jian"></i></div>
                        <div class="number" @click="setNumber(item)"><input v-model="item.Eat_Number" readonly/></div>
                        <div class="add" @click="addItem(item)"><i class="iconfont icon-jia"></i></div>
                    </div>
                </div>
            </div>
            <div class="footer-box">
                <div class="total-box">
                    <span>数量:{{total.number}}份</span> &nbsp;
                    <span>小计:<span class="money"><span class="unit">￥</span>{{total.money.toFixed(2)}}</span></span>
                </div>
                <div class="bnts"> 
                    <div class="bnt" @click="back"><i class="iconfont icon-chexiao"></i>返回</div>
                    <div class="bnt bnt-del" @click="allDel"><i class="iconfont icon-shanchu"></i>清空</div>
                    <div class="flex1"></div>
                    <div class="bnt-save" @click="saveEdit()"><i class="iconfont icon-queren"></i>确认修改</div>
                </div>
            </div>
        </div>
        <div class="right-food-box">
            <div class="category-nav food-main-box"  v-if="orderMap_Type==2 ||orderMap_Type==1" :style="foodMainStyle">
                <categorys-page 
                    :data="foodMainCategory" 
                    :row="foodMainArg.row" 
                    :col="foodMainArg.col" 
                    :selectIndex="mainCategoryIndex"
                    :bottomH="setBottomH"
                    :pageIndex="foodMainPageIndex"
                    navFirstName="全部大类"
                    v-slot="{item}" @navClick="onFoodNav">
                    {{item.MainCategory_Name}}
                </categorys-page>
            </div>
            <div class="category-nav food-sub-box"  v-if="orderMap_Type==3 ||orderMap_Type==1" :style="foodSubStyle">
                <categorys-page  
                    :data="foodSubCategorys" 
                    :row="foodSubArg.row" 
                    :col="foodSubArg.col" 
                    :selectIndex="subCategoryIndex"
                    :bottomH="setBottomH"
                    :pageIndex="foodSubPageIndex"
                    navFirstName="全部小类"
                    v-slot="{item}" @navClick="onFoodSubNav">
                    {{item.SubCategory_Name}}
                   <b v-show="subCategoryNumberKey[item.SubCategory_ID]>0">{{subCategoryNumberKey[item.SubCategory_ID]}}</b>
                </categorys-page>
            </div>

            <div class="menu" :style="menuStyle">
                <!-- 菜单 -->
                <layout-rc class="item-box clearfix" :row="arg.row" :col="arg.col" :marginW="2" :marginH="2" :isVarCss="true">
                    <div class="item-li" v-for="item in foodsPages" :key="item"  
                        v-show="!item.Is_OnlySendInSetmeal"
                        @click="onPlaceFoods(item)">
                        <div class="title">
                            <i class="iconfont icon-tesecai" v-show="sysSetting.RunOrderListShowSpecialFoodFlag && item.Is_Special"></i>{{item.Food_Name}}
                        </div>
                        <b v-show="getFoodNumber(item)>0">{{getFoodNumber(item)}}</b>
                        <div class="bottom-box" v-if="item.Is_Limited && item.Is_LimitedProject">
                            <div class="text-left" v-if="item.Is_Promotion || (item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price)">剩: <span class="red">{{item.RemainNum}}</span></div>
                            <div class="bottom-flex-box">
                                <!-- 促销价 -->
                                <div class="cxPrice" v-if="item.Is_Promotion">
                                    <div class="cxTag">促</div>
                                    <div class="unit">￥</div>{{item.Promotion_Price}}
                                </div>
                                <!-- vip 价格 -->
                                <div class="vipPrice" v-else-if="item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price">
                                    <div class="vipTag">VIP</div>
                                    <div class="price"> 
                                        <div class="unit">￥</div>{{item.Food_VipPrice}}
                                    </div>
                                </div>
                                <div class="text-left" v-else>剩: <span class="red">{{item.RemainNum}}</span></div>
                                <div class="text-right">￥{{item.Food_Price}}/{{item.Food_Size}}</div>
                            </div>
                        </div>
                        <div class="bottom-box bottom-flex-box" v-else>
                            <!-- 促销价 -->
                            <div class="cxPrice" v-if="item.Is_Promotion">
                                <div class="cxTag">促</div>
                                <div class="unit">￥</div>{{item.Promotion_Price}}
                            </div>
                            <!-- vip 价格 -->
                            <div class="vipPrice" v-else-if="item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price">
                                <div class="vipTag">VIP</div>
                                <div class="price"> 
                                    <div class="unit">￥</div>{{item.Food_VipPrice}}
                                </div>
                            </div>
                            <div class="text-right">￥{{item.Food_Price}}/{{item.Food_Size}}</div>
                        </div>

                        <tag-sold-out v-if="item.Is_SoldOut && !item.MultipleSizeFoods?.some(it=>!it.Is_SoldOut)"></tag-sold-out>
                        <div class="tag tag-grey" v-if="!item.Is_SoldOut && item.Is_Limited && item.Is_LimitedProject && item.RemainNum==0">售罄</div>
                    </div>
                </layout-rc>
            </div>
            <div class="search-box">
                <key-board-input class="search"
                    ref="searchBox"
                    type="text" v-model="varietySelect" placeholder="菜品模糊检索"
                    isKeyEnterClose isBlurClose
                    :focusLock="true"
                    :keyOptions="{isKeyDownEnter:true}"
                ></key-board-input>
                <div class="bnt shuaxin-bnt" @click="RefreshData()"><i class="iconfont icon-a-shuaxin3x"></i>刷新</div>
                <div class="float-right">
                    <span class="last-page iconfont icon-fangxiangquan-left" @click="pageBotton()"></span>
                    <span class="page-number">{{ pageIndex}}/{{ pageCount }}页</span>
                    <span class="next-page iconfont icon-fangxiangquan-right" @click="pageBotton(1)" ></span>
                </div>
            </div>
        </div>

        <modal-load :isShow="isShowNumber">
            <number-modal :isShow="isShowNumber" title="请输入数量" type="number" :dplaces="2" :value="numItem?.Eat_Number"
                @close="isShowNumber=false" @confirm="popupReturn" />
        </modal-load>
        <!--菜品换单位-->
        <modal-load :isShow="unitShow">
            <change-Unit-Model  :isShow="unitShow" @closeModel="unitShow=false" :multipleSizeFoods="theMultipleSizeFoods" @onPlaceFoods="onPlaceFoods" ></change-Unit-Model>
        </modal-load>
    </div>
</template>

<script>
import {changeUnitModel} from '../../diningTable/diningDetail/index.js'
//添加菜品
export default {
    name:"selectFoodList",
    components:{
        changeUnitModel
    },
    data(){
        return {
            unitShow:false,
            //多单位的菜品数据
            theMultipleSizeFoods:null,
            menuStyle:{},
            //大类 样式
            foodMainStyle:{},
            foodMainArg:{row:2,col:8},
            //小类 样式
            foodSubStyle:{},
            foodSubArg:{row:2,col:8},
            /**大类导航 选择 */
            mainCategoryIndex:0,
            /**小类导航 选择 */
            subCategoryIndex:0,
            //大类分页 当前页码 
            foodMainPageIndex:1,
            //小类分页 当前页码 
            foodSubPageIndex:1,
            /**菜品页码 */
            pageIndex:1,
            varietySelect:"",
            isShowNumber:false,
            //自选
            freeList:[],
            numItem:null
        }
    },
    computed:{
        //基础参数配置
        sysSetting(){
            return this.$cacheData?.globalVariable?.GlobalSysSetting;
        },
        /**点菜界面类别显示方式 1：大类+小类，2：大类，3：小类 */
        orderMap_Type(){
            console.log( this.sysSetting.OrderMap_Type)
            return this.sysSetting.OrderMap_Type||1;
        },
        arg(){
            if(this.sysSetting){
                return {row:this.sysSetting.OrderMap_X,col:this.sysSetting.OrderMap_Y};
            }
            return {row:6,col:6};
        },
        //所以菜品数据
        getPosFoodData(){
            return this.$parent.getPosFoodData;
        },
        //大类
        foodMainCategory(){
            let mainCategory=this.getPosFoodData?.filter(it=>
                //排除推荐菜、套餐菜
                !it.Is_ForwardMainCategory && it.FoodSubCategorys.some(sub=>sub.PosFoods.some(food=>!food.Is_SetMeal))
            );
            return mainCategory;
        },
        //全部小类
        allSubCategorys(){
            let all=[];
            this.foodMainCategory?.forEach(it=>{
                it.FoodSubCategorys.forEach(sub=>{
                    //排除推荐菜、套餐菜
                    if(!sub.Is_ForwardSubCategory && sub.PosFoods.some(food=>!food.Is_SetMeal)){
                        all.push(sub);
                    }
                });
            });
            return all;
        },
        //小类
        foodSubCategorys(){
            let foodSubCategorys=this.allSubCategorys;
            if(this.mainCategoryIndex>0){//大类分类 第几
                foodSubCategorys=this.foodMainCategory[this.mainCategoryIndex-1].FoodSubCategorys;
            }
            return foodSubCategorys;
        },
        //分类 下菜品
        posFoods(){
            let list=[];
            if(this.subCategoryIndex>0){//分类 下菜品
                list=this.foodSubCategorys[this.subCategoryIndex-1].PosFoods;
            }else{//全部分类 下菜品 
                this.foodSubCategorys.forEach(it=>{
                    list=list.concat(it.PosFoods);
                })
            }
            //套餐菜
            return list.filter(food=>!food.Is_SetMeal);
        },
        //筛选 当前 菜品数据
        posFoodsFilter(){
            //排除 不允许单点
            let list=this.posFoods?.filter(it=>!it.Is_OnlySendInSetmeal);
            let menuTxt=this.varietySelect?.toLowerCase();
            if(menuTxt){
                list=list.filter(it=>(it.Food_Name||"").toLowerCase().indexOf(menuTxt)>=0 ||
                                     (it.Food_PinYin||"").toLowerCase().indexOf(menuTxt)>=0 || 
                                     (it.Food_Code||"").toLowerCase().indexOf(menuTxt)>=0
                                );
            }
            return list;
        },
        /**菜品分页显示 */
        foodsPages(){
            return this.posFoodsFilter?.slice((this.pageIndex-1)*this.pageSize,this.pageIndex*this.pageSize);
        },
        //一页多少条
        pageSize(){
            let size=this.arg.row*this.arg.col;
            return size;
        },
        //总条数
        pageCount(){
            return Math.ceil(this.posFoodsFilter.length/this.pageSize);
        },
        /**点单菜品的数量 未下单的菜品 */
        foodNumberKey(){
            let data={};
            this.freeList?.filter(it=>!it.is_taste)?.forEach(it=>{
                if(data[it.EAT_XFBMID]){
                    data[it.EAT_XFBMID]=Number((data[it.EAT_XFBMID]+Number(it.Eat_Number)).toFixed(2))
                }else{
                    data[it.EAT_XFBMID]=Number(it.Eat_Number);
                }
                it.FoodSetmeals?.forEach(item=>{
                    if(data[item.FoodSetmeal_ID]){
                        data[item.FoodSetmeal_ID]=Number((data[item.FoodSetmeal_ID]+Number(item.FoodSetmeal_Number)).toFixed(2))
                    }else{
                        data[item.FoodSetmeal_ID]=Number(item.FoodSetmeal_Number);
                    }
                })
            })
            return data;
        },
        /**小类下 点单菜品的数量 未下单的菜品 */
        subCategoryNumberKey(){
            let subCategory={};
            this.foodSubCategorys?.forEach(it=>{
                let number=0;
                it.PosFoods?.forEach(item=>{
                    if(this.foodNumberKey[item.Food_ID]>0){
                        number+=this.foodNumberKey[item.Food_ID];
                    }

                    item.MultipleSizeFoods?.forEach(it=>{
                        if(this.foodNumberKey[it.Food_ID]>0){
                            number+=this.foodNumberKey[it.Food_ID];
                        }
                    })
                })
                if(number>0){
                    number=Number(number.toFixed(2));
                    subCategory[it.SubCategory_ID]=number;
                }
            })
            return subCategory;
        },
        /**合计 */
        total(){
            let total={
                number:0,
                money:0
            };
            this.freeList.forEach(it=>{
                total.number=Number(total.number).compute(it.Eat_Number);
                total.money=Number(total.money).compute((it.Eat_Number*it.Eat_CheckPrice).toFixed(2));
            })
            return total;
        }
    },
    watch:{
        '$parent.isShow'(newVal){
            if(!newVal){
                this.init();
            }
        }
    },
    mounted(){
        this.$cacheData.DeskPosconfigure().then((d)=>{
            if(d){
                d.DisplayingConfigs?.forEach((it)=>{
                    let style={};
                    if(it.ScreenPx>0){
                        style["height"]=it.ScreenPx+"%";
                    }
                    if(it.Button_Color){
                        style["--bgColor"]=it.Button_Color;
                    }
                    if(it.Font_Name){
                        style["--fontFamily"]=it.Font_Name;
                    }
                    if(it.Font_Size){
                        style["--fontSize"]=it.Font_Size+"px"
                    }
                    if(it.Font_Color){
                        style["--fontColor"]=it.Font_Color
                    }
                    let arg={row:it.IntRow,col:it.IntCol};
                    if(it.Config_Kind==11){//菜品大类显示类型
                        this.foodMainArg=arg;
                        this.foodMainStyle=style;
                    }else if(it.Config_Kind==12){//为菜品小类显示类型   
                        this.foodSubArg=arg;
                        this.foodSubStyle=style;
                    }else if(it.Config_Kind==13){//为菜品显示类型   
                        this.menuStyle=style;
                    }
                })
            }
        }).catch(e=>{
            console.log("基本配置获取失败："+e.message);
        });
    },
    methods:{
        init(){
            this.freeList=this.$parent.freeList.map(it=>{
                return Object.assign({},it);
            });
        },
        back(){
            this.$parent.isShow=true;
        },
        setBottomH(){
            let top=this.$refs.searchBox?.getBoundingClientRect().top;
            if(top>0){
                return window.innerHeight-top;
            }
            return 0;
        },
        /**菜品点菜数量 标识 */
        getFoodNumber(item){
            let num=0;
            if(this.foodNumberKey[item.Food_ID]>0){
                num=this.foodNumberKey[item.Food_ID];
            }
            if(item.MultipleSizeFoods?.some(it=>this.foodNumberKey[it.Food_ID]>0)){
                item.MultipleSizeFoods.forEach(it=>{
                    if(this.foodNumberKey[it.Food_ID]>0){
                        num+=this.foodNumberKey[it.Food_ID];
                    }
                })
                num=Number(num.toFixed(4));
            }
            return num;
        },
        /**点击大类*/
        onFoodNav(item,index){
            if(item){
                this.mainCategoryIndex=index;
            }else{//所有
                this.mainCategoryIndex=0;
            }
            this.foodSubPageIndex=0;
            this.$nextTick(()=>{
                this.foodSubPageIndex=1;
            })
            this.onFoodSubNav(null,0)
        },
        /**点击小类*/
        onFoodSubNav(item,index){
            this.subCategoryIndex=index;
            this.varietySelect="";
        },
        /**数据分页 */
        pageBotton(type){
            if(type==1){
                if(this.pageIndex<this.pageCount){
                    this.pageIndex++;
                }else{//下一页
                    this.$message.warning('已到最后一页');
                }
            }else{//上一页
                if(this.pageIndex==1){
                    this.$message.warning('已到第一页');
                }
                this.pageIndex<=1?1:this.pageIndex--;
            }
        },
        //刷新菜品数据
        RefreshData(){
            const loading = this.$loading({
                text: "信息加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$cacheData.RefreshSoldInfo().then(()=>{
                loading.close();
            }).catch((e)=>{ 
                loading.close();
                this.$message.error("刷新失败:"+e.message);
            });
        },
        /**全清空 */
        allDel(){
            this.freeList=[];
        },
        //修改数量
        setNumber(item){
            this.isShowNumber=true;
            this.numItem=item;
        },
        popupReturn(num){
            if(!(num>0)){
                this.$message.warning("数量必须大于0!");
                return;
            }
            this.isShowNumber=false;
            this.numItem.Eat_Number=Number(num);
        },
        //减少
        removeItem(item,index){
            item.Eat_Number=Number(item.Eat_Number).compute(-1);
            if(item.Eat_Number<=0){
                this.freeList.splice(index,1);
            }
        },
        //增加
        addItem(item){
            item.Eat_Number=Number(item.Eat_Number).compute(1);
        },
        onPlaceFoods(item){
            if(!item){
                this.$message({message: '请先选择菜品',type: 'warning'});
                return
            }
            if(item.Is_SoldOut && !item.Is_MultipleSize){
                this.$message({message: '该菜品已售完',type: 'warning'});
                return
            }
            if(item.Is_Limited==true){
                if(item.RemainNum==0){
                    if(item.Is_LimitedProject){
                        this.$message({message: '该菜品已售完',type: 'warning'});
                        return;
                    }
                }
                //不存在限量
            }
            /**判断是否多规格菜品 */
            if(item.Is_MultipleSize==true){
                this.unitShow=true;
                this.theMultipleSizeFoods=item;
                return
            }
            this.unitShow=false;
            
            let food=this.freeList.find(it=>it.EAT_XFBMID==item.Food_ID);
            if(food){
                food.Eat_Number++;
            }else{
                let food=this.$parent.getFoodInfo(item);
                this.freeList.push(food);
            }
        },
        //保存修改
        saveEdit(){
            this.$parent.freeList=this.freeList;
            this.back();
        }
    }
}
</script>

<style lang="scss" >
@import './selectFoodList.scss';
</style>